import moment from "moment";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { getBatteryByDeviceId } from "../../api/firebase/functionCallables/telekomCallables";
import { DeviceBatteryType } from "../../api/firebase/types/device.types";
import TooltipButton from "../../components/buttons/TooltipButton";

type DeviceBatteryTemplateProps = {
  deviceId: string;
};

const DeviceBatteryTemplate: React.FC<DeviceBatteryTemplateProps> = ({
  deviceId,
}) => {
  const [battery, setBattery] = useState<DeviceBatteryType>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkBattery();
  }, []);

  const checkBattery = async () => {
    const batteryMeasurement = await getBatteryByDeviceId(deviceId);
    setBattery(batteryMeasurement);
    setLoading(false);
  };

  const getColor = () => {
    if (!battery || battery.value >= 40) return "black";
    if (battery.value >= 20) return "orange";
    return "red";
  };

  const batteryToolTip = (
    <TooltipButton
      id="tooltip-btn-no-battery"
      tooltip="Der Akkustand wird beim Absetzen eines Notrufes ermittelt. Um den aktuellen Akkustand zu ermitteln, können Sie jederzeit einen Test-Notruf im Testmodus absetzen."
    />
  );

  if (loading)
    return (
      <div>
        <ProgressSpinner style={{ width: "20px", height: "20px" }} />
      </div>
    );

  if (!battery?.value) return <div>Unbekannt</div>;

  return (
    <div className="p-ai-center" style={{ color: getColor() }}>
      {`${battery.value}% (${battery.date.from(moment())})`}
    </div>
  );
};

export default DeviceBatteryTemplate;
